import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=ef432b12"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=ef432b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports